<template>
<v-container>
    <v-row class="border-bottom">
             <v-col cols="12">
                 <h1 class="mainheading white--text">Welcome {{this.user.displayName}}</h1>
             </v-col>
             <v-col cols="12" sm="3" md="3" lg="3">
              <v-card
                  elevation="2"
                  flat
                to="/fighters"   
                  class="primary rounded-xl"
                      >
                      <v-card-title class="white--text">
                          <v-row 
                              align="center"
                              justify="center"
                          >
                              <v-col cols="7" class="text-center">
                                  <v-icon size="60" color="white" class="mb-3">mdi-account-multiple</v-icon>
                                  <h3>All Fighters</h3>
                              </v-col>
                              <v-col cols="5" class="text-center">
                                <h1>{{this.fighters.length}}</h1>
                              </v-col>
                          </v-row>
                          
                      </v-card-title>
                      </v-card>
                  </v-col> 
                  <v-col cols="12" sm="3" md="3" lg="3">
              <v-card
                elevation="2"
                flat
                to="/fights"  
                  class="primary rounded-xl"
                      >
                      <v-card-title class="white--text">
                          <v-row 
                              align="center"
                              justify="center"
                          >
                              <v-col cols="7" class="text-center">
                                  <v-icon size="60" color="white" class="mb-3">mdi-account-switch</v-icon>
                                  <h3>All Fights</h3>
                              </v-col>
                              <v-col cols="5" class="text-center">
                                <h1>{{this.loaded_fights.length}}</h1>
                              </v-col>
                          </v-row>
                          
                      </v-card-title>
                      </v-card>
                  </v-col> 
      </v-row>
</v-container>
</template>

<script>
  // import HelloWorld from '../components/HelloWorld'
import { mapGetters } from 'vuex'
  export default {
    name: 'Home',
    data: () => ({

    }),
    computed: {
        ...mapGetters([
            'user',
            'fighters',
            'loaded_fights'
            ]),
    }

    // components: {
    //   HelloWorld,
    // },
  }
</script>

<style lang="sass" scoped>
.fas 
    font-size: 60px

// far 
//     font-size: 60px
 
</style>
